import type { ReactNode } from 'react'
import { UserList } from '@components'
import { useNavigate, createFileRoute } from '@tanstack/react-router'
import type { WithCompanyId } from '@terros/common'
import { useRequiredParams } from '@util'

function Users(): ReactNode {
  const { companyId } = useRequiredParams<WithCompanyId>()
  const navigate = useNavigate()
  return <UserList back companyId={companyId} onRowClick={(user) => navigate({ to: `./${user.userId}` })} />
}

export const Route = createFileRoute('/companies_/$companyId_/user/')({
  component: Users,
})
